'use strict';

class FindMemberOrganisationBranch {
    constructor() {
        this.branchDropdown = document.querySelector("#fmo-branch-list");        
        if (this.branchDropdown) {
            var allOptions = this.branchDropdown.querySelectorAll("option");
            [].forEach.call(allOptions, option => {
                if (option.value === "") {
                    option.setAttribute("disabled", "disabled");
                }
            });
            if (this.branchDropdown.value) {
                this.selectBranch(this.branchDropdown);
            }
            this.branchDropdown.addEventListener("change", evt => {
                evt.preventDefault();
                this.selectBranch(evt.target);
            });
        }        
    }    
    selectBranch(a) {        
        //Dispatch event
        document.dispatchEvent(new CustomEvent("fmo.branchSelected", {
            detail: { branch: a.value }
        }));        
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new FindMemberOrganisationBranch();
});